window.jQuery = window.$ = require("jquery")